export default __webpack_public_path__ + "static/media/urls-page.8584fc89.png";